import firebase from 'firebase';

export const initializeFirebase = () => {
  firebase.firestore.DocumentSnapshot.prototype.data = (function(baseDataFn) {
    return function patchedData(options) {
      if (options == null) {
        options = {
          serverTimestamps: "estimate"
        };
      }
      return baseDataFn.call(this, options);
    };
  })(firebase.firestore.DocumentSnapshot.prototype.data);
  
  firebase.initializeApp({
    apiKey: "AIzaSyDij6QCIMfrU3sYtSDu-7Wo2y8jsEC-2N4",
    authDomain: "blabla-c57da.firebaseapp.com",
    databaseURL: "https://blabla-c57da.firebaseio.com",
    projectId: "blabla-c57da",
    storageBucket: "blabla-c57da.appspot.com",
    messagingSenderId: "503752727399",
    appId: "1:503752727399:web:b277eda47c52d67917edc2"
  });

  return firebase.firestore().enablePersistence({synchronizeTabs: true});
};